<template>
    <div>
        <v-toolbar app flat>
            <v-toolbar-title>
                <v-icon>insert_photo</v-icon>
                LifeSkills Admin
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn flat>
                    <v-icon left>person</v-icon>
                    {{ user.name || user.email }}
                </v-btn>
                <v-divider vertical></v-divider>
                <v-btn flat @click="logout">
                    <v-icon left>logout</v-icon>
                    Logout
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-content>
            <v-container fluid>
                <keep-alive>
                    <Users :user="user"></Users>
                </keep-alive>
            </v-container>
        </v-content>
    </div>
</template>

<script>
import api from '@/api';
import router from '@/router';
import Users from '@/components/admin/Users';
import { includes } from 'lodash';

export default {
    name: 'Admin',
    components: { Users },
    data() {
        return {
            user: {}
        };
    },
    computed: {},
    methods: {
        logout() {
            api.get('/logout').then(() => {
                router.replace({ name: 'home' });
            });
        }
    },
    mounted() {},
    beforeDestroy() {},
    beforeRouteEnter(to, from, next) {
        api.get('/login')
            .then(response => {
                const user = response.data;
                if (!includes(user.roles, 'admin')) {
                    return next({ name: 'home', replace: true });
                }
                next(vm => {
                    vm.user = user;
                });
            })
            .catch(() => {
                next({ name: 'home', replace: true });
            });
    }
};
</script>

<style scoped>
::v-deep .v-btn {
    text-transform: none;
}
</style>
